"use client";

import { memo } from "react";
import type { PipelineNodeStatus } from "../../types";

const BAR_COLORS: Record<string, string> = {
  active: "bg-blue-500",
  completed: "bg-emerald-400",
  failed: "bg-red-500",
};

const TRACK_COLORS: Record<string, string> = {
  planned: "bg-gray-100/50",
  pending: "bg-gray-100",
  active: "bg-gray-200",
  completed: "bg-emerald-100",
  failed: "bg-gray-200",
};

export const ProgressBar = memo(function ProgressBar({
  percent,
  status,
}: {
  percent: number;
  status: PipelineNodeStatus;
}) {
  const isSubtle = status === "planned" || status === "pending";
  const color = isSubtle
    ? "bg-gray-200"
    : (BAR_COLORS[status] ?? "bg-gray-300");
  const track = TRACK_COLORS[status] ?? "bg-gray-200";
  const barPercent = isSubtle
    ? 0
    : status === "completed"
      ? 100
      : Math.max(Math.min(percent, 100), 0);

  return (
    <div className={`w-full h-1.5 ${track} rounded-full overflow-hidden`}>
      <div
        className={`h-full rounded-full transition-all duration-300 ${color}`}
        style={{ width: `${barPercent}%` }}
      />
    </div>
  );
});
